var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { hasMobileMenu: _vm.showMobileMenu }, attrs: { id: "header" } },
    [
      _c("div", { staticClass: "main-header" }, [
        _c("div", { staticClass: "container" }, [
          _c(
            "div",
            { staticClass: "header-left-side" },
            [
              _c(
                "button",
                {
                  staticClass: "btn px-0 sidebar-toggle-button",
                  on: {
                    click: function($event) {
                      return _vm.toggleMobileMenu()
                    }
                  }
                },
                [
                  !_vm.itr && !_vm.peppr
                    ? _c("img", {
                        attrs: {
                          src: "/images/nav-icon.svg",
                          alt: "Navigation trigger"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.itr || _vm.peppr
                    ? _c("img", {
                        attrs: {
                          src: "/images/itr/burgerwhite.png",
                          alt: "Navigation trigger"
                        }
                      })
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c("language-selection", {
                staticClass: "d-none d-lg-block",
                attrs: { screen: "desktop" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("a", { attrs: { href: _vm.regionRelativeUrl("/"), id: "logo" } }, [
            _c("div", { staticClass: "header-logo" }, [
              _vm.isVipPunter
                ? _c("span", { staticClass: "vip-tag" }, [_vm._v("vip")])
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "header-right-side" },
            [
              !_vm.currentUser
                ? _c("div", { staticClass: "header-auth-buttons" }, [
                    _c(
                      "a",
                      {
                        staticClass:
                          "btn btn-outline-primary my-1 btn-register mr-sm-0",
                        attrs: {
                          href: _vm.regionRelativeUrl("/users/registration/")
                        }
                      },
                      [
                        _c("span", { staticClass: "d-none d-sm-block" }, [
                          _vm._v(
                            _vm._s(_vm.translate.home.registerForFreeButton)
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "d-block d-sm-none" }, [
                          _vm._v(
                            _vm._s(
                              _vm.translate.home.registerForFreeButtonMobile
                            )
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass:
                          "black-link mx-3 mx-md-2 mx-lg-3 d-none d-sm-inline-block btn-nav-login",
                        attrs: { href: _vm.regionRelativeUrl("/users/login/") }
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.translate.login.login) +
                            "\n                    "
                        )
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.currentUser &&
              (_vm.isEscort || _vm.isVenue) &&
              !_vm.isGoldUser(this.currentUser)
                ? _c(
                    "a",
                    {
                      staticClass:
                        "btn btn-outline-primary btn-register btn-mr btn-upgrade-gold",
                      attrs: {
                        href: _vm.regionRelativeUrl(
                          "/users/products/buy-premium"
                        )
                      },
                      on: {
                        click: function($event) {
                          return _vm.trackUpgradeClick("navbar_upgrade_gold")
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "d-none d-sm-block" }, [
                        _vm._v(_vm._s(_vm.translate.product.upgradeGoldDesktop))
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "d-block d-sm-none" }, [
                        _vm._v(_vm._s(_vm.translate.product.upgradeGold))
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.currentUser && _vm.isPunter && !_vm.isVipPunter
                ? _c(
                    "a",
                    {
                      staticClass:
                        "btn btn-outline-primary btn-register btn-mr btn-upgrade-vip",
                      attrs: {
                        href: _vm.regionRelativeUrl(
                          "/users/products/punter-vip"
                        )
                      },
                      on: {
                        click: function($event) {
                          return _vm.trackUpgradeClick("navbar_upgrade_vip")
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "d-none d-sm-block" }, [
                        _vm._v(_vm._s(_vm.translate.product.upgradeVipDesktop))
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "d-block d-sm-none" }, [
                        _vm._v(_vm._s(_vm.translate.product.upgradeVip))
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("language-selection", {
                staticClass: "d-block d-lg-none",
                attrs: { screen: "mobile" }
              }),
              _vm._v(" "),
              !_vm.showMobileMenu &&
              _vm.currentUser &&
              (_vm.isEscort || _vm.isVenue || _vm.isPunter)
                ? _c(
                    "a",
                    {
                      staticClass: "btn px-0 message-dropdown-button",
                      class: { "logged-in": _vm.currentUser },
                      attrs: {
                        href: _vm.regionRelativeUrl("/users/account/messages")
                      }
                    },
                    [
                      _c("icon-component", {
                        attrs: { width: "2em", icon: _vm.fa_comments_alt() }
                      }),
                      _vm._v(" "),
                      _vm.conversationUnreadMessageCount
                        ? _c("div", { staticClass: "notification-counter" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.conversationUnreadMessageCount) +
                                "\n                    "
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "dropdown" }, [
                !_vm.showMobileMenu
                  ? _c(
                      "a",
                      {
                        staticClass: "btn px-0 user-dropdown-button",
                        class: { "logged-in": _vm.currentUser },
                        attrs: {
                          href: _vm.regionRelativeUrl(
                            _vm.currentUser
                              ? "/users/account/"
                              : "/users/login/"
                          )
                        }
                      },
                      [
                        _c("icon-component", {
                          class: _vm.isVipPunter ? "vip-user" : "",
                          attrs: {
                            icon: _vm.isVipPunter
                              ? _vm.vip_user_icon()
                              : _vm.fa_user(),
                            height: _vm.isVipPunter ? "28px" : "1em"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showMobileMenu
                  ? _c(
                      "a",
                      {
                        staticClass: "user-dropdown-close",
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.closeMobileMenu()
                          }
                        }
                      },
                      [
                        _c("icon-component", {
                          attrs: {
                            viewBox: "-55 75 512 512",
                            icon: _vm.fa_times()
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.isUserAdmin
                ? [
                    _c(
                      "a",
                      {
                        staticClass: "btn px-0 user-dropdown-button",
                        attrs: { href: _vm.regionRelativeUrl("/admin/users") }
                      },
                      [
                        _c("icon-component", {
                          attrs: { icon: _vm.fa_crown(), height: "1em" }
                        })
                      ],
                      1
                    )
                  ]
                : _vm._e()
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _vm.regionData
        ? _c("div", { staticClass: "header-navigation-wrap" }, [
            _c("div", { staticClass: "container" }, [
              _c(
                "nav",
                { staticClass: "header-navigation" },
                _vm._l(
                  _vm.lodash.get(_vm.regionData, "navBarLinks", []),
                  function(link) {
                    return _c(
                      "a",
                      { attrs: { href: _vm.regionRelativeUrl(link.path) } },
                      [_vm._v(_vm._s(link.title))]
                    )
                  }
                ),
                0
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.regionData
        ? _c("div", { attrs: { id: "mobileMenu" } }, [
            _c(
              "nav",
              { staticClass: "mobile-navigation mb-4" },
              _vm._l(
                _vm.lodash.get(_vm.regionData, "navBarLinks", []),
                function(link) {
                  return _c(
                    "a",
                    { attrs: { href: _vm.regionRelativeUrl(link.path) } },
                    [_vm._v(_vm._s(link.title) + "\n            ")]
                  )
                }
              ),
              0
            ),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex justify-content-center" }, [
              _c(
                "a",
                {
                  staticClass: "btn btn-secondary mt-2",
                  attrs: {
                    href: _vm.regionRelativeUrl(
                      _vm.currentUser ? "/users/account/" : "/users/login/"
                    )
                  }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.translate.account.myAccount) +
                      " "
                  ),
                  _c("icon-component", {
                    staticClass: "ml-3",
                    attrs: { icon: _vm.fa_user() }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm.currentUser
              ? _c("div", { staticClass: "d-flex justify-content-center" }, [
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-with-icon btn-logout",
                      attrs: { href: _vm.regionRelativeUrl("/users/logout/") }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.translate.login.logout) +
                          " "
                      ),
                      _c("icon-component", {
                        attrs: { icon: _vm.fa_sign_out_alt() }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex justify-content-center mt-4" },
              [_c("region-selector-component", { staticClass: "w-50" })],
              1
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-55d307cc", { render: render, staticRenderFns: staticRenderFns })
  }
}